import { CalendarPreferences } from "@/features/calendar/components/Preferences/CalendarPreferences";
import type { Preferences, UUID } from "@/core/types";

import { useProviderProfile } from "../api/queries/useProviderProfile";
import { useUpdateProviderProfile } from "../api/mutations/useUpdateProviderProfile";

type CalendarPreferencesCardProps = {
  providerId?: UUID;
};

export function CalendarPreferencesCard({ providerId }: CalendarPreferencesCardProps) {
  const { data: profileData } = useProviderProfile(providerId);
  const { mutateAsync } = useUpdateProviderProfile(providerId, {
    meta: { component: "CalendarPreferencesCard" },
  });

  const handleUpdate = (newPreferences: Preferences) =>
    mutateAsync({ body: { preferences: newPreferences }, providerId });

  return <CalendarPreferences onUpdate={handleUpdate} preferences={profileData?.preferences} />;
}
